//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback, useContext, useEffect, useState } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { loadProfileByEmployerId } from '../../common/services/empMyProfileServices';
import { loadEmployerData } from '../../common/services/appServices';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdEditDialog from '../../common/elemental/AfitdEditDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import BrandPage from './BrandPage';
import BrandPageUnavailable from './BrandPageUnavailable';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        props,
        brandEmployerId,
        employer,
        // setEmployer,
        // employerProfileData,
        // setEmployerProfileData,
        handleCloseBrandPageDialog,
    } = params;
    const { open } = props;

    const defns = {
        brandPageDialog: {
            fullScreen: true,
            open,
            // isDirty,
            onClose: handleCloseBrandPageDialog,
            hideActions: true,
        },
        brandPage: {
            employerId: brandEmployerId,
            employer,
        },
        brandPageNotAvailable: {
            employer,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const BrandPageDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { employerId: brandEmployerId, onClose } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [employer, setEmployer] = useState();
    const [employerProfileData, setEmployerProfileData] = useState();

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // viewing brand page, fetch employer data first
    useEffect(() => {
        if (brandEmployerId) {
            // a work-around to delay the firebase call so the app can call firebase.initializeApp() first.
            setTimeout(() => {
                loadEmployerData({
                    employerId: brandEmployerId,
                    setEmployer,
                });
            }, 200);
        }
    }, [brandEmployerId]);

    // fetch profile data when employer data is loaded
    useEffect(() => {
        if (brandEmployerId && employer) {
            loadProfileByEmployerId({
                employerId: brandEmployerId,
                setData: setEmployerProfileData,
            });
        }
    }, [brandEmployerId, employer]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isPublic = _get(employerProfileData, 'isPublic'); // do not set default value as we want the undefined state in order to show blank

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleCloseBrandPageDialog = useCallback(() => {
        onClose();
    }, [onClose]);

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, brandEmployerId, employer, setEmployer, employerProfileData, setEmployerProfileData, handleCloseBrandPageDialog });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...layoutContext, profileData: employerProfileData }}>
            <AfitdEditDialog {...defns.brandPageDialog}>
                {isPublic === true && <BrandPage {...defns.brandPage} />}
                {isPublic === false && <BrandPageUnavailable {...defns.brandPageNotAvailable} />}
            </AfitdEditDialog>
        </LayoutContext.Provider>
    );
};

export default BrandPageDialog;
